// extracted by mini-css-extract-plugin
export default {"about":"About_about__tFYRZ","about-heading":"About_about-heading__NovH3","about-para":"About_about-para__23wcq"};